<template>
  <div class="topbar-item">
    <div id="kt_quick_user_toggle">
      <div class="symbol" style="cursor: pointer">
        <img class="symbol-label" :src="picture" alt=""/>
      </div>
    </div>

    <div
        id="kt_quick_user"
        ref="kt_quick_user"
        class="offcanvas offcanvas-right p-10"
    >
      <perfect-scrollbar
          class="offcanvas-content pr-5 mr-n5 scroll"
          style="max-height: 90vh; position: relative;"
      >
        <div class="d-flex align-items-center mt-10">
          <div class="symbol symbol-100 mr-5">
            <img class="symbol-label" :src="picture" alt=""/>
          </div>
          <div class="d-flex flex-column">
            <a
                href="#"
                class="font-weight-bold font-size-h5 text-dark-75 text-hover-primary"
            >
              {{ this.$store.state.auth.user.name }}
            </a>
            <div class="navi mt-2">
              <a href="#" class="navi-item">
                <span class="navi-link p-0 pb-2">
                  <span class="navi-text text-muted text-hover-primary">
                    {{ this.$store.state.auth.user.email }}
                  </span>
                </span>
              </a>
            </div>
            <v-btn color="#00004d" dark class="btn btn-bold" @click="onLogout">
              Sign Out
              <v-icon dark x-small class="ml-1">fas fa-sign-out-alt</v-icon>
            </v-btn>
          </div>
        </div>
        <div class="separator separator-dashed mt-8 mb-5"></div>
        <div class="navi navi-spacer-x-0 p-0">
          <div class="navi-link">
            <div class="navi-text">
              <v-btn color="#00004d" dark class="btn btn-bold" style="width: 100%" @click="shCpDialog">
                Change Password
                <v-icon dark x-small class="ml-1">fas fa-lock</v-icon>
              </v-btn>
            </div>
          </div>
          <br>
          <div class="navi-link" v-if="$store.state.auth.user.type === 1">
            <div class="navi-text">
              <v-btn color="#00004d" dark class="btn btn-bold" style="width: 100%" @click="shCCDialog">
                Change Global Settings
                <v-icon dark x-small class="ml-1">fas fa-cog</v-icon>
              </v-btn>
            </div>
          </div>
          <br v-if="$store.state.auth.user.type === 1">
          <div class="navi-link">
            <div class="navi-text">
              <v-btn color="#00004d" dark class="btn btn-bold" style="width: 100%" @click="openManageDevicesDialog">
                Manage Devices
                <v-icon dark x-small class="ml-1">fas fa-laptop</v-icon>
              </v-btn>
            </div>
          </div>
        </div>
        <div class="separator separator-dashed mt-5"></div>
      </perfect-scrollbar>
    </div>

    <v-dialog persistent v-model="manageDevicesDialog" max-width="520px">
      <v-card>
        <v-card-title class="font-weight-bold text-dark">
          Login Devices
        </v-card-title>
        <v-card-text>
          <div v-if="devicesLoading" class="text-muted font-size-sm">Loading devices...</div>
          <div v-else-if="loginDevices.length === 0" class="text-muted font-size-sm">
            No trusted devices yet.
          </div>
          <div
              v-else
              v-for="device in loginDevices"
              :key="device.id"
              class="device-item mb-3 p-3 rounded"
              :class="{ 'device-item-current': device.is_current }"
          >
            <div class="d-flex justify-content-between align-items-start">
              <div class="font-weight-bold text-dark font-size-sm pr-2">
                {{ device.device_name || 'Unknown device' }}
              </div>
              <span v-if="device.is_current" class="device-current-badge">Current</span>
            </div>
            <div class="device-meta font-size-sm mt-1">IP: {{ device.machine_address }}</div>
            <div class="device-meta font-size-sm" v-if="device.last_used_at">
              Last used: {{ formatDeviceDate(device.last_used_at) }}
            </div>
            <div class="device-meta font-size-sm" v-if="device.verified_at">
              Verified: {{ formatDeviceDate(device.verified_at) }}
            </div>
            <button
                type="button"
                class="btn btn-sm device-logout-btn mt-3"
                :disabled="removingDeviceId === device.id"
                @click="removeDevice(device)"
            >
              {{ removingDeviceId === device.id ? 'Removing...' : 'Logout device' }}
            </button>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="closeManageDevicesDialog">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style lang="scss" scoped>
#kt_quick_user {
  overflow: hidden;
}

.device-item {
  background-color: #f3f6f9;
  border: 1px solid #ebedf3;
}

.device-meta {
  color: #3f4254;
}

.device-item-current {
  border-color: #163891;
}

.device-current-badge {
  background-color: #163891;
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  line-height: 1;
  padding: 6px 10px;
  border-radius: 9999px;
  white-space: nowrap;
}

.device-logout-btn {
  background-color: #ffffff;
  border: 1px solid #163891;
  color: #163891;
  font-weight: 600;
  border-radius: 9999px;
  padding: 6px 14px;

  &:hover:not(:disabled) {
    background-color: #163891;
    color: #ffffff;
  }

  &:disabled {
    opacity: 0.6;
  }
}
</style>

<script>
import {DO_LOGOUT, FETCH_LOGIN_DEVICES, REMOVE_LOGIN_DEVICE} from "@/core/services/store/auth.module";
import {SET_SNACK} from "@/core/services/store/snackbar.module";
import KTLayoutQuickUser from "@/assets/js/layout/extended/quick-user.js";
import KTOffcanvas from "@/assets/js/components/offcanvas.js";
import {bus} from "@/main";
import {mapState} from "vuex";

export default {
  name: "KTQuickUser",
  data() {
    return {
      manageDevicesDialog: false,
      loginDevices: [],
      devicesLoading: false,
      removingDeviceId: null,
    };
  },
  mounted() {
    KTLayoutQuickUser.init(this.$refs["kt_quick_user"]);
  },
  methods: {
    openManageDevicesDialog() {
      this.manageDevicesDialog = true;
      this.loadLoginDevices();
    },
    closeManageDevicesDialog() {
      this.manageDevicesDialog = false;
    },
    loadLoginDevices() {
      if (!this.$store.state.auth.isAuthenticated) {
        return;
      }

      this.devicesLoading = true;
      this.$store
          .dispatch(FETCH_LOGIN_DEVICES)
          .then((data) => {
            this.loginDevices = data.records.devices || [];
          })
          .catch(() => {
            this.loginDevices = [];
          })
          .finally(() => {
            this.devicesLoading = false;
          });
    },
    removeDevice(device) {
      const deviceLabel = device.device_name || "this device";
      const message = device.is_current
          ? `Remove "${deviceLabel}" from trusted devices? You will stay signed in, but a verification code will be required next time you sign in from this device.`
          : `Remove "${deviceLabel}" from trusted devices? A verification code will be required next time you sign in from it.`;

      if (!window.confirm(message)) {
        return;
      }

      this.removingDeviceId = device.id;
      this.$store
          .dispatch(REMOVE_LOGIN_DEVICE, device.id)
          .then((data) => {
            this.$store.dispatch(SET_SNACK, {
              clr: "success",
              msg: data._metadata.message
            });
            this.closeManageDevicesDialog();
          })
          .catch(() => {
            this.$store.dispatch(SET_SNACK, {
              clr: "error",
              msg: "Unable to remove login device."
            });
          })
          .finally(() => {
            this.removingDeviceId = null;
          });
    },
    formatDeviceDate(value) {
      if (!value) {
        return "";
      }

      const date = new Date(value);
      if (Number.isNaN(date.getTime())) {
        return value;
      }

      return date.toLocaleString(undefined, {
        year: "numeric",
        month: "numeric",
        day: "numeric",
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
        hour12: true
      });
    },
    onLogout() {
      this.closeManageDevicesDialog();
      this.$store.dispatch(DO_LOGOUT);
    },
    closeOffcanvas() {
      new KTOffcanvas(KTLayoutQuickUser.getElement()).hide();
    },
    shCpDialog() {
      bus.$emit('cPDialogOpen', true);
    },
    shCCDialog() {
      bus.$emit('cCDialogOpen', true);
    },
  },
  computed: {
    ...mapState({
      errors: state => state.users.errors
    }),
    picture() {
      if (this.$store.state.auth.user.image_public_url) {
        return this.$store.state.auth.user.image_public_url
      } else {
        return process.env.BASE_URL + "media/users/default.jpg";
      }
    }
  }
};
</script>
